import {
  Component,
  ChangeDetectorRef,
  ElementRef,
  Renderer2,
  signal,
  OnInit,
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { inject } from '@angular/core';
import { CompanyDomain } from './modules/auth/models/CompanyDomain';
import { AuthService } from './services/auth/auth.service';
import { CustomSpinnerComponent } from './modules/shared/custom-components/custom-spinner/custom-spinner.component';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, CustomSpinnerComponent],
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authService = inject(AuthService);
  private changeDetector = inject(ChangeDetectorRef);
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private _document = inject(DOCUMENT);
  private titleService = inject(Title);
  private library = inject(FaIconLibrary);

  title = 'EnwageFrontend';
  isLoaded = signal(false);
  abc = '#c23434';

  companyDomain = signal<CompanyDomain>({
    companyDomain: '',
    companyLoginBackground: '',
    companyLoginLogo: '',
    companyLoginMain: '',
    primaryColor: '',
    secondaryColor: '',
    companyFavIcon: '',
    isDefault: false,
    companyLogo: '',
    companyId: 0,
    companyName: '',
    companyLoaderGif: '',
    companyLogoBase64: ''
  });

  constructor() {
    // Add the imported pro icons to the library
    this.library.addIconPacks(fas, far, fal, fab);
  }

  updateSCSSVariable(value: string) {
    const hostElement = this.elementRef.nativeElement;
    this.renderer.setStyle(hostElement, '--custom-color', value);
  }

  async ngOnInit() {
    const url = window.location.hostname;
    await this.authService.getCompanyByDomainName(url);
    await this.authService.getEmployeeAccessModules();

    const domain = this.authService.companyDomain;
    this.companyDomain.set(domain);

    if (domain.isDefault) {
      // @ts-ignore
      this._document
        .getElementById('appFavicon')
        .setAttribute('href', 'favicon.ico');
      this.titleService.setTitle(`Enwage`);
    } else {
      // @ts-ignore
      this._document
        .getElementById('appFavicon')
        .setAttribute('href', domain?.companyFavIcon);
      this.titleService.setTitle(domain.companyName == '' ? "Enwage" : domain.companyName)
    }
  }
}
